import {  SITE_URL } from "/constants/API_constants.js";
const baseRedirectUrl = SITE_URL+'/redirect'; // Change this to your actual redirect path

export function wrapLinkInSafeRedirect(originalUrl) {
    const encodedUrl = encodeURIComponent(originalUrl);
    return `${baseRedirectUrl}?url=${encodedUrl}`;
}